// extracted by mini-css-extract-plugin
export default {"description":"index-module__Yqn88","select":"index-module__doeBH"};